import { Elements } from '@stripe/react-stripe-js';
import { useMemo } from 'react';

import { PortalPaymentMethodType } from '@common-lib';
import { RiveAnimation } from '@frontend-libs/portal';

import { useStripeContext } from '@frontend/utils';

import { StripeElements } from './stripe-elements.component';

export interface PaymentMethodSelectorProps {
  paymentMethods: PortalPaymentMethodType[];
  onPaymentMethodSelected: (paymentMethod: PortalPaymentMethodType) => void;
}

export const PaymentMethodSelector = (props: PaymentMethodSelectorProps) => {
  const { stripePromise, elementOptions } = useStripeContext();

  const isStripeCheckout = useMemo(() => {
    return props.paymentMethods.includes('stripe');
  }, [props.paymentMethods]);

  return (
    <>
      {isStripeCheckout && (!stripePromise || !elementOptions) && (
        <>
          <RiveAnimation src="/rive/loading.riv" height={128} />
        </>
      )}

      {isStripeCheckout && stripePromise && elementOptions && (
        <Elements stripe={stripePromise} options={elementOptions}>
          <StripeElements
            onChange={(selected) => {
              if (selected) {
                props.onPaymentMethodSelected('stripe');
              }
            }}
          />
        </Elements>
      )}
    </>
  );
};
